<template>
  <div class="new-project-item">
    <div class="new-project-item-wrapper">
      <div class="project-cover" @click="gotoPage">
        <div class="cover-img" :style="{'background-image':'url('+hostUrl +projectData.picture+')'}"></div>
        <div v-if="hasTheme && projectData.theme != ''" class="project-themes clearfix">
          <div class="theme-tag">
            <div class="theme-name">{{projectData.theme}}</div>
          </div>
        </div>
      </div>
      <div class="project-desc">
        <h5 class="project-name" @click="gotoPage">{{projectData.event_name}}</h5>
        <div class="project-sub-name">{{projectData.event_summary}}</div>
        <div class="project-location">
          <div>
            <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />
          </div>
          <div class="text">{{projectData.city}}</div>
        </div>
        <div v-if="hasProcess && projectData.plan_status != '1'" class="project-location">
          <div>
            <img class="icon" src="~@static/fundingnew/profile/icon-like.png" />
          </div>
          <div class="text">{{projectData.total}}</div>
        </div>
        <div @click="gotoPage" class="project-link pink-circle-btn" v-if="hasLink">查看详情</div>
      </div>
    </div>

    <tags-list v-if="hasTags" :tags="projectData.tags"></tags-list>
  </div>
</template>

<script>
import TagsList from '@components/TagsList'
import { behavior } from '@/utils/behavior'
export default {
  components: {
    TagsList
  },
  props: {
    hasTags: Boolean,
    hasDesc: Boolean,
    hasProcess: Boolean,
    hasLink: Boolean,
    hasTheme: Boolean,
    isAnnouncement: Boolean,
    isWeekly: Boolean,
    projectData: Object,
    isBili: Boolean,
    isCalendar: Boolean,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      likedLeast: 100,
      link: '',
    }
  },
  methods: {
    gotoPage() {
      let query = this.$route.query
      if (this.isBili) {
        query.path_from = 'bili'
      }
      if (this.isCalendar) {
        query.path_from = 'calendar'
        _jcq.push([
          '_track',
          'calendarinfo_check',
          {
            title: this.projectData.event_name,
          },
        ])
        behavior({ behavior_code: 'prc_bhv_abs_calendar_bc1', name: this.projectData.event_name })
      } else {
        _jcq.push([
          '_track',
          'yjhbcinfo_check',
          {
            title: this.projectData.event_name,
          },
        ])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc3', name: this.projectData.event_name })
      }
      this.$router.push({ path: this.link, query })
    },
  },
  mounted() {
    this.link = '/fundingnew/project/' + this.projectData.id
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fundingnew/new-project-item.scss';
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/ProjectItem.vue